import { empApi } from "./client";

// Căn hộ theo dự án -> { items, pagination }
export const getProjectApartmentsApi = (params) => empApi.get("/apartment/app", params);

// Căn hộ theo đợt mở bán -> { items, pagination }
export const getEventApartmentsApi = (params) =>
  empApi.get("/apartmentSaleOpeningEventLink/apartments", params);
